module.exports = __webpack_public_path__ + "feather.0b17bdf43a7e08497753.eot";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/feather/fonts/feather.eot?9xfrq8
// module id = ../../../../../src/assets/fonts/feather/fonts/feather.eot?9xfrq8
// module chunks = styles